import React, { useEffect, useState } from "react";
import { Form, Input, Modal, Select, Button, Row, Col, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getCountries } from "../../store/actions/country";
import { getStates } from "../../store/actions/state";
import { getCity } from "../../store/actions/city";
import { getPackage } from "../../store/actions/package";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

const { Option } = Select;

const CustomerForm = ({ visible, onCreate, onCancel, record, form }) => {
  // const [form] = Form.useForm();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const dispatch = useDispatch();
  // const StateList = useSelector((state) => state.state.list);
  // const countryList = useSelector((state) => state.country.list);
  const cityList = useSelector((state) => state.city.list);
  const packageReducer = useSelector((state) => state.packageReducer.list);

  useEffect(() => {
    dispatch(getCity());
    dispatch(getPackage());
  }, [dispatch]);

  useEffect(() => {
    if (record) {
      // form.setFieldsValue(record);
      form.setFieldsValue({
        ...record,
        password: undefined, // Clear password field when editing a record to avoid showing it
      });

      setSelectedCountry(record.coId);
      setSelectedState(record.stId);
    } else {
      form.resetFields();
      setSelectedCountry(null);
      setSelectedState(null);
    }
  }, [record, form]);

  return (
    <Modal
      visible={visible}
      title={record ? "Update Customer" : "Add Customers"}
      okText="Submit"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            values.amount = Number(values?.amount || 0);
            values.limit = Number(values?.limit || 0);
            values.gstin = values?.gstin || "";
            // console.log("values :", values);
            onCreate(values);
            form.resetFields();
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="customer_form"
        initialValues={record}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: "Please input the name!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="mobile"
              label="Mobile"
              rules={[
                { required: true, message: "Please input the mobile number!" },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Mobile number must be exactly 10 digits!",
                },
              ]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="contactName"
              label="contact Name"
              rules={[
                { required: true, message: "Please input the contact Name!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="contactMobile"
              label="Alternative Mobile"
              rules={[
                {
                  required: false,
                  message: "Please input the contact Mobile number!",
                },
              ]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: "Please input the email!" },
                {
                  type: "email",
                  message: "Please enter a valid email address!",
                },
              ]}
            >
              <Input type="email" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="address"
              label="Address"
              rules={[{ required: true, message: "Please input the address!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="gstin"
              label="GSTIN"
            // rules={[{ required: true, message: "Please input the gstin!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="limit"
              label="limit"
              rules={[{ required: true, message: "Please input the limit!" }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="username"
              label="username"
              rules={[
                { required: true, message: "Please input the username!" },
                { min: 6, message: "Username must be at least 6 characters!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="password"
              label="Password"
              rules={[
                {
                  required: true,
                  message: "Minimum 8 Characters Required!",
                  min: 8,
                },
              ]}
            >
              <Input
                type={passwordVisible ? "text" : "password"}
                addonAfter={
                  <Button
                    icon={
                      passwordVisible ? (
                        <EyeInvisibleOutlined />
                      ) : (
                        <EyeOutlined />
                      )
                    }
                    onClick={togglePasswordVisibility}
                    shape="circle"
                    size="small"
                  />
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          {/* <Col span={8}>
            <Form.Item
              name="countryId"
              label="Country"
              rules={[{ required: true, message: "Please select a country!" }]}
            >
              <Select 
                placeholder="Select a country"
                onChange={handleCountryChange}
              >
                {countryList.map((country) => (
                  <Option key={country._id} value={country._id}>
                    {country.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="stateId"
              label="State"
              rules={[{ required: true, message: "Please select a state!" }]}
            >
              <Select 
                placeholder="Select a state"
                onChange={handleStateChange}
              >
                {filteredStates.map((state) => (
                  <Option key={state._id} value={state._id}>
                    {state.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col> */}
          <Col span={8}>
            <Form.Item
              name="cityId"
              label="City"
              rules={[{ required: true, message: "Please select a city!" }]}
            >
              <Select
                showSearch
                placeholder="Select a city"
                filterOption={(input, option) => {
                  // Convert both input and city name to lowercase for case-insensitive search
                  return option.children
                    .toLowerCase()
                    .includes(input.toLowerCase());
                }}
              >
                {cityList.map((city) => (
                  <Option key={city.id} value={city.id}>
                    {city.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {!record?.id ? (<><Col span={8}>
            <Form.Item
              name="pId"
              label="Package"
              rules={[{ required: true, message: "Please select a Package!" }]}
            >
              <Select
                showSearch
                placeholder="Select a package"
                filterOption={(input, option) => {
                  // Convert both input and city name to lowercase for case-insensitive search
                  return option.children
                    .toLowerCase()
                    .includes(input.toLowerCase());
                }}
              >
                {packageReducer.map((packageComp) => (
                  <Option key={packageComp.id} value={packageComp.id}>
                    {packageComp.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
            <Col span={8}>
              <Form.Item
                name="amount"
                label="amount"
                rules={[{ required: true, message: "Please input the amount!" }]}
              >
                <Input type="number" />
              </Form.Item>
            </Col></>) : null}

        </Row>
        {!record?.id ? (<>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="paymentMode"
                label="Payment Mode"
                rules={[
                  { required: true, message: "Please select a Payment Mode!" },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select a payment Mode"
                  filterOption={(input, option) => {
                    // Convert both input and city name to lowercase for case-insensitive search
                    // return option.children.toLowerCase().includes(input.toLowerCase());
                  }}
                >
                  <Option value={"Razorpay"}>Razorpay</Option>
                  <Option value={"Cash"}>Cash</Option>
                  <Option value={"Bank"}>Bank</Option>
                  <Option value={"NEFT"}>NEFT</Option>
                  <Option value={"UPI"}>UPI</Option>
                  {/* {packageReducer.map((packageComp) => (
                  <Option key={packageComp.id} value={packageComp.id}>
                    {packageComp.name}
                  </Option>
                ))} */}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="paymentRec"
                label="Payment Status"
                valuePropName="checked" // This tells the form to treat the checkbox's value as 'checked' or 'unchecked'
                rules={[
                  {
                    required: false,
                    message: "Please confirm if payment is received!",
                  },
                ]}
              >
                <Checkbox>Full Payment Received</Checkbox>
              </Form.Item>
            </Col>
            {/* <Col span={8}>
            <Form.Item
              name="paymentRec"
              label="payment Received"
              rules={[
                {
                  required: true,
                  message: "Please input the payment Received!",
                },
              ]}
            >
              <Input type="number" />
            </Form.Item>
          </Col> */}
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              {/* <Form.Item
          name="referral"
          label="referral"
        >
          <Input  />
        </Form.Item> */}
            </Col>
            {/* <Col span={8}>
              <Form.Item
                name="startDate"
                label="Start Date"
                rules={[{ required: true, message: "Please choose start date!" }]}
              >
                <Input type="date" />
              </Form.Item>
            </Col> */}
          </Row></>) : null}

        {/* <Form.Item
          name="role"
          label="Role"
          hidden
        >
          <Input value={3} type='hidden' />
        </Form.Item> */}
      </Form>
    </Modal>
  );
};

export default CustomerForm;
